/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import { useState ,useEffect, useCallback, useRef} from 'react'
import './App.css'
import { motion } from 'framer-motion'
import React from 'react'
import NavigationRoutes from './routes'
import {  useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import GlobalContext from './components/Context/GloablContext';
import Toast from './components/Toast';
import refreshIdToken from './CommonMethods/RefreshIdFunction'
import { dataService } from './services/data.services'
import { handleSystemConfig } from './redux/systemConfigSlice'
import { websocketURL } from './config'
import { userService } from './services/user.services'
import { fetchImageAsBlob, getPDFImage, storePDFImage } from './components/HelpGuideModal/indexDB';
import { getAuthItem, clearAuthSession, broadcastLogout, subscribeToAuthEvents, setAuthItem, syncSessionFromLocalStorage } from './CommonMethods/authSession';

function App(props) {
    const navigate=useNavigate()
    const navigationPath = NavigationRoutes(props)
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [Toastmessage, setToastmessage] = useState('');  
    const [confirmationStateCancel, setConfirmationStateCancel] = useState(false)
    const [confirmationState, setConfirmationState] = useState(false)
    const [ToastWarnmessage, setToastWarnmessage] = useState('')
    const restrict = useSelector(state=>state?.systemConfigData?.restrict)
    const [isSideBar, setIsSideBar] = useState(restrict);
    const [systemConfigDateformat, setSystemConfigDateformat] = useState('')
    const [getData, setGetData] = useState()
    const dispatch=useDispatch()
    const editingUserIdRef = useRef('');
    const [editSocket,setEditSocket] = useState(false)

    const handleCrossTabLogout = useCallback(() => {
        const arcmTrustToken = localStorage.getItem('arcm_trust_browser_token');
        const logoutFromAllTabs = localStorage.getItem('LogoutfromAllTabs');
        clearAuthSession();
        localStorage.clear();
        if (arcmTrustToken) {
            localStorage.setItem('arcm_trust_browser_token', arcmTrustToken);
        }
        if (logoutFromAllTabs) {
            localStorage.setItem('LogoutfromAllTabs', logoutFromAllTabs);
        }
        localStorage.setItem('showLogoutToast', 'true');
        setTimeout(() => {
            window.location.reload();
            navigate('/');
        }, 500);
    }, [navigate]);

    const WebSocketConnection = useCallback(() =>{
        console.log("coming inside socket");
        const email = getAuthItem('email') || '';
        const ws = new WebSocket(`${websocketURL}?user=${encodeURIComponent(email)}`); 
        window.websocket = ws
        ws.onopen = () => {
            setEditSocket(ws)
        };
        ws.onclose = () => {
            const editedUserId = editingUserIdRef.current;
            // console.log("looo",location?.pathname?.replace(location?.pathname?.substring(location.pathname.lastIndexOf("/") + 1), ":id"))
            const localToken = localStorage.getItem('IdToken');
            const hasToken = localToken === null ? getAuthItem('IdToken') : localToken;
            if(hasToken){
             
                editedUserId!==''?WebSocketConnection('start',editedUserId):WebSocketConnection(); // 3 seconds delay, adjust as needed
            }
        }
        ws.onerror = (error) => {
            console.error('WebSocket error:', error);
            // Attempt to reconnect after a delay
            setTimeout(WebSocketConnection, 3000); // 3 seconds delay, adjust as needed
        };
    }, []);

    const handleRefreshToken = async () => {
        if(getAuthItem('IdToken')){
            refreshIdToken()
        }
    };

    useEffect(() => {
        if(getAuthItem('custom:is_first_time_login') === 'true'){
            navigate('/reset-password')
        }
        if(getAuthItem('IdToken')){
            refreshIdToken()
            WebSocketConnection()   
        }
        const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
       
    }, []);

    const handleClear=()=>{
        if((Toastmessage&&Toastmessage!=='')||(toastErrorMessage&&toastErrorMessage!=='')){
            setToastmessage('');
            setToastErrorMessage();
        }
    }  
    
    const [globalVariables, setGlobalVariables] = useState({
        "date_format": "",
        "country_code": "",
        "max_file_size": "",
        "email_addr": "",
        "session_timeout": "",
        "public_encryp_key": "",
        "browser_trust_duration": "",
        "temp_pass_duration": "",
        "recent_otp_durn": "",
        "max_failed_attempts": "",
        "otp_validity_durn": ""
    })

    const [vital_information, setVitalInfo] = useState({
        "blood_glucose": " ",
        "blood_pressure": " ",
        "temperature": " ",
        "SP02": " ",
        "pulse": " ",
        "weight": " ",
        "height": " "
    })

    useEffect( () => {
        const fetchData = async()=>{
        // setLoading(true )
        let response
        response = await dataService.systemConfigDataFromAdmin();
        if (response.error === false) {
            setGetData(response.data.data)
            dispatch(handleSystemConfig(response.data))
            const Getdata = response.data
            setSystemConfigDateformat((prev) => ({
                ...prev,
                "date_format": response?.data?.global_variables.date_format,
                "blood_glucose": response?.data?.vital_information?.blood_glucose,
                "blood_pressure": response?.data?.vital_information?.blood_pressure,
                "temperature": response?.data?.vital_information?.temperature,
                "SP02": response?.data?.vital_information?.SP02,
                "pulse": response?.data?.vital_information?.pulse,
                "weight": response?.data?.vital_information?.weight,
                "height": response?.data?.vital_information?.height,
            }))
            setGlobalVariables((prev) => ({
                ...prev,
                "date_format": Getdata?.global_variables?.date_format,
                "country_code": Getdata?.global_variables?.country_code,
                "max_file_size": Getdata?.global_variables?.maximum_file_size,
                "email_addr": Getdata?.global_variables?.email_address,
                "session_timeout": Getdata?.global_variables?.session_timeout,
                "public_encryp_key": Getdata?.global_variables?.public_encryption_key,
                "browser_trust_duration": Getdata?.global_variables?.browser_trust_duration,
                "temp_pass_duration": Getdata?.global_variables?.temporary_password_expiry_duration,
                "recent_otp_durn": Getdata?.global_variables?.resend_otp_duration,
                "max_failed_attempts": Getdata?.global_variables?.max_failed_login_attempts,
                "otp_validity_durn": Getdata?.global_variables?.otp_validity_duration
            }))
            setVitalInfo((prev) => ({
                ...prev,
                "blood_glucose": Getdata?.vital_information?.blood_glucose,
                "blood_pressure": Getdata?.vital_information?.blood_pressure,
                "temperature": Getdata?.vital_information?.temperature,
                "SP02": Getdata?.vital_information?.SP02,
                "pulse": Getdata?.vital_information?.pulse,
                "weight": Getdata?.vital_information?.weight,
                "height": Getdata?.vital_information?.height,
            }))
        }
    }
    if(getAuthItem('IdToken')){
        fetchData()
    }
    }, [])

    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) 
                    return; // Prevent multiple logout calls
                
                const message = event.data;
                
                if (message === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    broadcastLogout();
                    handleCrossTabLogout();
                }
            };
        }
    },[editSocket, handleCrossTabLogout])

    useEffect(() => {
        const unsubscribe = subscribeToAuthEvents((eventType) => {
            if (eventType === 'logout') {
                handleCrossTabLogout();
            }
            if (eventType === 'login') {
                syncSessionFromLocalStorage();
                if (getAuthItem('IdToken')) {
                    WebSocketConnection();
                }
            }
        });
        return unsubscribe;
    }, [handleCrossTabLogout, WebSocketConnection]);

    const fetchAndCacheHelpGuides = async () => {
        try {
            const apiResponse = await dataService.GetAPI('users/help-guides?getAllFiles=true'); 
            const files = apiResponse?.data?.files || {}; 
            for (const [fileName, fileUrl] of Object.entries(files)) {
                const pageKey = `${fileName}_page_1`;
                const cachedImage = await getPDFImage(pageKey);
                if (cachedImage) {
                    continue; // Skip if already cached
                }
    
                const imgBlob = await fetchImageAsBlob(fileUrl);
                if (imgBlob) {
                    await storePDFImage(pageKey, imgBlob);
                }
            }
        } catch (error) {
            console.error("Error fetching help guides:", error);
        }
    };

    return (
       
        <GlobalContext.Provider value={{ confirmationState,setConfirmationState,confirmationStateCancel,setConfirmationStateCancel,setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage, setToastWarnmessage,ToastWarnmessage, isSideBar, setIsSideBar,WebSocketConnection,editSocket, fetchAndCacheHelpGuides
        }}>
            <motion.div
                initial={{ opacity: 0 }}
                onClick={()=>handleClear()}
                animate={{ opacity: 1 }}
            >
                {navigationPath}
                {Toastmessage!==''&&Toastmessage!==undefined &&<Toast 
                    message={Toastmessage}
                    type="success"
                    setToastmessage={setToastmessage} />}
                {toastErrorMessage!==''&&toastErrorMessage!==undefined &&<Toast 
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
                {ToastWarnmessage!==''&&ToastWarnmessage!==undefined &&<Toast 
                    message={ToastWarnmessage}
                    type="warn"
                    setToastmessage={setToastWarnmessage} />}
            </motion.div>
        </GlobalContext.Provider>
    )
}

export default App
